var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "m16.95 5.979l-5.662.051v1.376l.292 2.52l.437 1.165l.741.6l.185 3.309l.792-.72l2.555-.03V15l.754.343l.236.193l1.375.171V7.75l-.248-.429l-.412-.33l-.261-.386l-.514-.308l-.27-.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00F",
    d: "M12.857 11.143h.428v1.714h-.428zm0 2.143h.428v.428h-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M5.571 11.571h7.286v7.286H5.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.143 11.143h7.285v7.285H5.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M5.143 9.433h5.571V18H5.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M8.143 7.714H12v2.572H8.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M8.571 7.281h3V9h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M9 7.714h2.571V9H9zm1.774-2.143H8.94v.343h-.37v1.372h2.572V5.914h-.369z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M9.428 6h1.286v1.286H9.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.714 7.281h.429v.429h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M10.714 6h.429v.429h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.714 5.571h.429V6h-.429zm0 1.286h.429v.429h-.429zM9.428 6h1.286v.429H9.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M10.285 5.571h.429V6h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M9.428 5.571h.857V6h-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M9.428 5.143h1.286v.428H9.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.571 8.143H12v2.143h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M11.143 8.576h.428v1.714h-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M10.285 9.857H5.571V18H12v-6.429h-1.715z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00F",
    d: "M6.428 11.571h3.429V12H6.428zm0 .857h4.715v.43H6.428zm0 .858h4.715v.428H6.428zm0 .857h4.715v.428H6.428zm0 .857h4.715v.428H6.428zm0 .857h4.715v.429H6.428zm0 .857h4.715v.429H6.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M6.857 7.286h.428V8.57h-.428zm.428-.429h.429v.429h-.429zm1.286-1.286H9V6h.428v.429h.429v.428h-.429v.429H9v.428h-.43v-.857h-.857V6.43h.857zM15 18.857v-.428h-1.286v.428zm.428-.428V18H15v.428zm1.286-1.286v-.429h-.429v-.428h-.428v-.429h-.429v.429H15v.428h-.429v.429h.857V18h.429v-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M9.428 8.571h.429V9h-.429zm.857 0h.429V9h-.429zM9 8.143h.428v.428H9zm.857 0h.428v.428h-.428zm.857 0h.429v.428h-.429zm0 2.143h.429v.428h-.429zm.429.428h.428v.429h-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M11.143 10.286h.428v.428h-.428zm.428.428H12v.429h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00F",
    d: "M12 10.714h.857v.429H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M9 9h.428v.429H9zm.857 0h.428v.429h-.428zm.857 0h.429v.429h-.429zM9 7.286h.428v.428H9zm.857 0h.428v.428h-.428zm.857 0h.429v.428h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M9.428 6.857h1.286v.429H9.428zM17.143 6h.428v.429h-.428zm.428.429H18v.428h-.429zm.429.428h.428v.429H18zm.428.429h.429v.428h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.143 7.714h1.714v.429h-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00F",
    d: "M12.857 7.714h1.714v.429H15v1.714h-.429v.429h-1.714v-.429h-.429V8.143h.429zm1.286.429h-.858v1.714h.858zm1.714 2.571h1.714v.429H18v1.714h-.429v.429h-1.714v-.429h-.429v-1.714h.429zm1.286.429h-.858v1.714h.858zm-1.715-3.429h.857v2.572h-.857zm-1.285 3H15v2.572h-.857zm3-2.571H18v2.143h-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M13.714 13.714h2.571v.429h-2.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.714 14.143h2.571v.428h-2.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M13.285 14.143h.429v.428h-.429zm3 0h.429v.428h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.285 14.571h.429v.857h-.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.285 15h.858v.428h-.858zm.858.428h1.714v.43h-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.428 7.714h.429v8.143h-.429zm-5.571 6.857h.857v.857h-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M16.714 14.571h.429V15h-.429zm.429.429h1.285v.428h-1.285zm0-9.429h-6V6h5.571v2.143h.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.143 6h.428v1.286h-.428z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCore);
export default __webpack_public_path__ + "static/media/core.66fe484c33ed43f6ba04b10b67686956.svg";
export { ForwardRef as ReactComponent };